import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SolidMenuItem = ({ menu }) => {
    const location = useLocation();

    return (
        <li className={location.pathname === menu.route ? 'active' : ''}>
            <Link to={menu.route}>
                {menu.icon}
                {menu.menuValue}
            </Link>
        </li>
    );
};

export default SolidMenuItem;
